import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";
import { calorPeriodManagementRoute } from "../period-management/route";

export const calorPeriodsManagementRoute: RouteConfig<'with-page'> = {
    name: 'Periods',
    path: '/calor/periods',
    page: lazy(() => import('.')),
    roles: ['ncassAdmin'],
    dynamicChildren: [
        calorPeriodManagementRoute,
    ]
}